import { Component, Input, OnInit, inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormElement } from '@app/modules/form-generator/edit-form-v3/models/form.model';
import { TranslateService } from '@ngx-translate/core';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import { MatChipInputEvent } from '@angular/material/chips';

@Component({
  selector: 'app-multiple-email-addresses-form-field',
  templateUrl: './multiple-email-addresses-form-field.component.html',
  styleUrls: ['./multiple-email-addresses-form-field.component.scss']
})
export class MultipleEmailAddressesFormFieldComponent implements OnInit {
  @Input() formElement: FormElement;
  @Input() parentGroup: UntypedFormGroup;
  @Input() readOnly: boolean;

  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  announcer = inject(LiveAnnouncer);

  // Email validation regex
  private emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  showValidEmailError: boolean;

  constructor(
    public translate: TranslateService,
  ) { }

  ngOnInit(): void {}

  get emailAddresses(): string[] {
    return this.parentGroup.get(this.formElement.formControl)?.value || [];
  }

  private isValidEmail(email: string): boolean {
    return this.emailRegex.test(email);
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    this.showValidEmailError = false;

    if (value) {
      if (!this.isValidEmail(value)) {
        this.announcer.announce(`${value} ${this.translate.instant('is not a valid email address')}`);
        this.showValidEmailError = true;
        return;
      }

      const emailArray = this.parentGroup.get(this.formElement.formControl)?.value || [];
      
      // Check for duplicates
      if (emailArray.includes(value)) {
        this.announcer.announce(`${value} ${this.translate.instant('is already added')}`);
        event.chipInput!.clear();
        return;
      }

      emailArray.push(value);
      this.parentGroup.get(this.formElement.formControl)?.setValue(emailArray);
      this.announcer.announce(`${value} ${this.translate.instant('has been added')}`);
    }

    // Clear the input value
    event.chipInput!.clear();
  }

  remove(email: string): void {
    const emailArray = this.parentGroup.get(this.formElement.formControl)?.value || [];
    const index = emailArray.indexOf(email);

    if (index >= 0) {
      emailArray.splice(index, 1);
      this.parentGroup.get(this.formElement.formControl)?.setValue(emailArray);
      this.announcer.announce(`${email} ${this.translate.instant('has been removed')}`);
    }
  }
}
